import { memo } from 'react';

import { SegmentedControlRow } from '~/components/ShareModal/components/SegmentedControlRow';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/** Page width segmented control (preview-only), bound to the design context. */
export const CreateShowcaseDesignPageWidthRow = memo(() => {
  const { pageWidthOptions, selectedPageWidthOption, handleSelectPageWidth } = useCreateShowcaseDesign();

  return (
    <SegmentedControlRow
      data-testid="CREATE_COLLECTION_LINK_DESIGN_PAGE_WIDTH_ROW"
      label="Page width"
      onSelect={handleSelectPageWidth}
      options={pageWidthOptions}
      selectedOption={selectedPageWidthOption}
    />
  );
});

CreateShowcaseDesignPageWidthRow.displayName = 'CreateShowcaseDesignPageWidthRow';
